import React from 'react';
import {
  Card,
  CardMedia,
  CardActions,
  Typography,
  Button,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PaletteIcon from '@mui/icons-material/Palette';

function MovieCard({ movie, onApplyTheme, onShowColors }) {
  const posterUrl = movie.poster_url ||
    (movie.poster_path ? `https://image.tmdb.org/t/p/w342${movie.poster_path}` : null);

  const year = movie.year || (movie.release_date && new Date(movie.release_date).getFullYear());

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        backgroundColor: 'background.paper',
      }}
    >
      {/* Poster with overlay title */}
      <Box sx={{ position: 'relative', paddingTop: '150%' /* 2:3 aspect ratio */ }}>
        {posterUrl ? (
          <CardMedia
            component="img"
            image={posterUrl}
            alt={movie.title}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255,255,255,0.05)',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No Poster
            </Typography>
          </Box>
        )}

        {/* Title overlay at bottom of poster */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'linear-gradient(transparent, rgba(0,0,0,0.9))',
            p: 1.5,
            pt: 4,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              color: 'white',
              fontWeight: 600,
              lineHeight: 1.2,
              fontSize: '0.85rem',
            }}
          >
            {movie.title}
          </Typography>
          {year && (
            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: '0.75rem',
              }}
            >
              {year}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Action buttons */}
      <CardActions
        sx={{
          p: 1,
          gap: 0.5,
          backgroundColor: 'rgba(0,0,0,0.2)',
        }}
      >
        <Button
          size="small"
          startIcon={<PlayArrowIcon sx={{ fontSize: '1rem' }} />}
          onClick={() => onApplyTheme(movie)}
          variant="contained"
          sx={{
            flex: 1,
            fontSize: '0.7rem',
            py: 0.5,
            px: 1,
            minHeight: 32,
          }}
        >
          Apply Theme
        </Button>
        {onShowColors && (
          <Tooltip title="View Colors">
            <IconButton
              size="small"
              onClick={() => onShowColors(movie)}
              sx={{
                backgroundColor: 'rgba(255,255,255,0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.2)',
                },
                width: 32,
                height: 32,
              }}
            >
              <PaletteIcon sx={{ fontSize: '1rem', color: 'white' }} />
            </IconButton>
          </Tooltip>
        )}
      </CardActions>
    </Card>
  );
}

export default MovieCard;
